import {useCallback} from "react";
import {useAppSelector} from "../../../../redux/hooks";
import {
  getDoesMySongsPageHaveSearchValue,
  getMySongsPageSearchValue
} from "../../../songs-router/modules/my-songs-page-store/mySongsPage.selectors";
import {mySongsPageStore,} from "../../../songs-router/modules/my-songs-page-store/mySongsPage.store";
import {InputRefType, useInputRef} from "../../../../components/common/hooks/useInputRef";

export interface ISongsSearchControlsLogic {
  isMobileSearchActive: boolean,
  searchValue: string,
  searchInputRef: InputRefType;

  handleSearchInputFocus: () => void,
  handleSearchInputBlur: () => void,
  handleSearchInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
}

export const useSongsSearchControlsLogic = (): ISongsSearchControlsLogic => {
  const isMobileSearchMenuActive = useAppSelector(() => mySongsPageStore.isMenuActive(`mobile.search`));
  const doesSearchHaveValue = useAppSelector(getDoesMySongsPageHaveSearchValue);

  const isMobileSearchActive: boolean = (isMobileSearchMenuActive || doesSearchHaveValue);

  const searchValue = useAppSelector(getMySongsPageSearchValue);

  const handleSearchInputChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const {value} = event.currentTarget;
    mySongsPageStore.setSearchValue(value);
  }, []);

  const searchInputRef = useInputRef();

  return {
    isMobileSearchActive,
    searchValue,
    searchInputRef,
    handleSearchInputFocus: () => mySongsPageStore.setSearchFocus(true),
    handleSearchInputBlur: () => mySongsPageStore.setSearchFocus(false),
    handleSearchInputChange
  };
}
